module.exports = __webpack_public_path__ + "static/media/home-cover.642076e6.png";